let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jfANH")).then(() => parcelRequire('fjkOG'));